import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "file-arae" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("NEW+ ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Manage Your Dao Members.", -1)
const _hoisted_4 = { style: {"margin-left":"10px"} }
const _hoisted_5 = { style: {"width":"120px"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Dao Id ")
const _hoisted_7 = { style: {"width":"300px"} }
const _hoisted_8 = { style: {"width":"120px"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Dao Name ")
const _hoisted_10 = { style: {"width":"300px"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"120px"} }, "Operator ", -1)
const _hoisted_12 = { style: {"width":"300px","margin-left":"0px"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"120px"} }, "Address ", -1)
const _hoisted_14 = { style: {"width":"300px"} }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("cancel")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("confirm")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h4", null, "Create A New Green Dao.", -1)
const _hoisted_18 = { style: {"margin-left":"10px"} }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { style: {"width":"120px"} }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Id ")
const _hoisted_22 = { style: {"width":"300px"} }
const _hoisted_23 = { style: {"width":"120px"} }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Name ")
const _hoisted_25 = { style: {"width":"300px"} }
const _hoisted_26 = { style: {"width":"120px"} }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Description ")
const _hoisted_28 = { style: {"width":"300px"} }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { style: {"width":"120px"} }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Type ")
const _hoisted_32 = { style: {"width":"300px","margin-left":"0px"} }
const _hoisted_33 = { style: {"width":"120px"} }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Website ")
const _hoisted_35 = { style: {"width":"300px"} }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"120px"} }, null, -1)
const _hoisted_37 = { style: {"width":"300px"} }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Select Folder")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Upload")
const _hoisted_40 = { style: {"width":"120px"} }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Avatar ")
const _hoisted_42 = { style: {"width":"300px"} }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"120px"} }, null, -1)
const _hoisted_44 = { style: {"width":"300px"} }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Select Image")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Upload")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("cancel")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("confirm")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Id: ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Owner: ")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Join")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Leave")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Manage")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("Learn")
const _hoisted_55 = /*#__PURE__*/_createTextVNode("Auction")
const _hoisted_56 = /*#__PURE__*/_createTextVNode("Grant")
const _hoisted_57 = /*#__PURE__*/_createTextVNode("Vote")
const _hoisted_58 = /*#__PURE__*/_createTextVNode("Prev ")
const _hoisted_59 = /*#__PURE__*/_createTextVNode("Next ")

import { getCurrentInstance, ComponentInternalInstance, ref } from 'vue'
import { connected, connectState } from "../libs/connect"
import { toRaw } from '@vue/reactivity'
import { genFileId } from 'element-plus'
import * as path from "path"
import type { UploadInstance, UploadProps, UploadRawFile, UploadFile, UploadFiles } from 'element-plus'

import * as constant from "../constant"
import * as tools from "../libs/tools"
import * as storage from '../libs/storage'
import * as element from "../libs/element"
import {GreenDao} from "../libs/greendao"


const __default__ = {
  name: 'DaosPage',
  props: {
  }
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

  
const { proxy } = getCurrentInstance() as ComponentInternalInstance;

const activeName = connectState.activeName;
const showAddNewDaoVisiable = ref(false);
const showManageDaoMemberVisiable = ref(false);

const uploadAvatar = ref<UploadInstance>();
const uploadWebsite = ref<UploadInstance>();
const avatarFileList = ref(new Array());
const websiteFileList = ref(new Array());

const greendao = new GreenDao();

const daoId = ref(0);
const daoName = ref('');
const daoDesc = ref('');
const daoWebsite = ref('');
const daoAvatarUrl = ref('');
const daoPublic = ref(true);

const daoMemberOperator = ref('');
const daoMemberAddress = ref('');

const loadStatus = ref(false);
const loadAvatarStatus = ref(false);
const loadWebsiteStatus = ref(false);
const loadDrawerStatus = ref(false);

const greenDaoList = ref(new Array());
const hasMore = ref(false);
const pageSize = ref(6);
const pageCount = ref(0);

const svg = `
        <path class="path" d="
          M 30 15
          L 28 17
          M 25.61 25.61
          A 15 15, 0, 0, 1, 15 30
          A 15 15, 0, 1, 1, 27.99 7.5
          L 15 15
        " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
      `;

//address explore url
const tokenExplorerUrl = (address:string, tokenId:string = '') => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      if(tokenId != ''){
        return `${blockExplorerUrls}/token/${address}?a=${tokenId}#inventory`
      }
      return `${blockExplorerUrls}/token/${address}`
    }
  }
  return address;
}

//address explore url
const addressExplorerUrl = (address:string) => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return `${blockExplorerUrls}/address/${address}`
    }
  }
  return address;
}      

//transaction explore url
const transactionExplorerUrl = (transaction:string) => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return blockExplorerUrls + '/tx/' + transaction;
    }
  }
  return transaction;
}

//parse the redirect url
const redirectUrl = (index:string, id:number) => {

  connectState.activeIndex.value = index;

  tools.setUrlParamter('activeIndex', index);  
  tools.setUrlParamter('daoId', id);
}

//on click to copy address
const onClickToCopy = async (content:string) => {
  tools.clickToCopy(content);
  
  element.elMessage('success', 'Copy ' + content + ' to clipboard success.');     
};

//on website folder change
const onChangeSelectWebsiteFolder = async (uploadFile: UploadFile, uploadFiles: UploadFiles) => {
  websiteFileList.value = toRaw(uploadFiles);
  
  daoWebsite.value = (websiteFileList.value[0].raw as any).webkitRelativePath.split(path.sep)[0];
  if(daoWebsite.value === ''){
    daoWebsite.value = (websiteFileList.value[0].raw as any).name;
  }
}

//on click to select website folder
const onSelectWebsiteFolder = async () => {
  uploadWebsite.value!.clearFiles();
}

//on click to upload website folder
const onUploadWebsiteFolder = async () => {
    try{

      loadWebsiteStatus.value = true;

      if(toRaw(websiteFileList.value).length === 0){
        element.elMessage('warning', 'You have not select any folder to upload!');
        return;
      }

      let directory = (websiteFileList.value[0].raw as any).webkitRelativePath.split(path.sep)[0];
      if(directory === ''){
        directory = (websiteFileList.value[0].raw as any).name;
      }

      let findIndex = false;

      for(const i in websiteFileList.value){
        const file = websiteFileList.value[i];
        if((file.raw as any).name === 'index.html'){
          findIndex = true;
          break;
        }
      }

      if(findIndex === false){
        element.elMessage('warning', 'Not a valid website folder, index.html not found in the root path!');
        return;
      }

      daoWebsite.value = await storage.uploadFolder(directory, toRaw(websiteFileList.value));
    }catch(e){
      element.alertMessage(e);
    }finally{
      loadWebsiteStatus.value = false;
    }
}

//on avatar file change
const onChangeSelectAvatarFile = async (uploadFile: UploadFile, uploadFiles: UploadFiles) => {
  avatarFileList.value = toRaw(uploadFiles);

  daoAvatarUrl.value = (avatarFileList.value[0].raw as any).name;
}

//on click to select avatar file
const onSelectAvatarFile = async () => {
  uploadAvatar.value!.clearFiles();
}

//replace the avatar file from old selected to new one
const handleAvtarExceed: UploadProps['onExceed'] = (files:any) => {
  uploadAvatar.value!.clearFiles();
  const file = files[0] as UploadRawFile;
  file.uid = genFileId();
  uploadAvatar.value!.handleStart(file);
};

//on click to upload avatar file
const onUploadAvatarFile = async () => {
    try{

      loadAvatarStatus.value = true;

      if(toRaw(avatarFileList.value).length === 0){
        element.elMessage('warning', 'You have not select any file to upload!');
        return;
      }

      daoAvatarUrl.value = await storage.uploadFile(toRaw(avatarFileList.value)[0]);
    }catch(e){
      element.alertMessage(e);
    }finally{
      loadAvatarStatus.value = false;
    }
}

//on click to open the drawer to add or delete a dao member
const onManageDaoMemberOpen = async () => {
  daoMemberOperator.value = 'add';
  daoMemberAddress.value = connectState.userAddr.value;
}

//click to cancel dao member update
const cancelDaoMemberUpdate = async () => {
  showManageDaoMemberVisiable.value = false;
}

//click to confirm to update dao members
const confirmDaoMemberUpdate = async () => {
  try{

      loadDrawerStatus.value = true;

      if(daoMemberOperator.value === 'add'){
        await onJoinDao(daoId.value, daoMemberAddress.value);
      }else if(daoMemberOperator.value === 'delete'){
        await onLeaveDao(daoId.value, daoMemberAddress.value);
      }else{
        element.alertMessage("invalid operator type!");
      }

      handleClick();

  }catch(e){
    element.alertMessage(e);
  }finally{
    loadDrawerStatus.value = false;
  }
}

//on click to open the drawer to create a new dao
const onAddNewDaoOpen = async () => {
  uploadAvatar.value!.clearFiles();
  uploadWebsite.value!.clearFiles();

  const currentClass = (proxy as any).$el.parentNode.querySelector(".upload-website");

  (currentClass.querySelector(".el-upload__input") as any).webkitdirectory = true;  
}

//on click to open the drawer to add new dao
const onAddGreenDao = async () => {
  daoId.value = 0;
  daoName.value = '';
  daoDesc.value = '';
  daoWebsite.value = '';
  daoAvatarUrl.value = '';
  daoPublic.value = true;  

  showAddNewDaoVisiable.value = true;
}

//on click to open the drawer to edit the dao
const onEditGreenDao = async (daoInfo:any) => {
  daoId.value = daoInfo.daoId;
  daoName.value = daoInfo.daoName;
  daoDesc.value = daoInfo.daoDesc;
  daoWebsite.value = daoInfo.daoWebsite;
  daoAvatarUrl.value = daoInfo.daoAvatar;
  daoPublic.value = daoInfo.daoPublic;   

  showAddNewDaoVisiable.value = true;
}

//on click to cancel dao update
const cancelDaoUpdate = async () => {
  showAddNewDaoVisiable.value = false;
}

//on click to confirm dao update
const confirmDaoUpdate = async () => {
  try{
    loadDrawerStatus.value = true;


    if(daoId.value > 0){
      const tx = await greendao.updateDao(daoId.value, daoName.value, daoDesc.value, daoWebsite.value, daoAvatarUrl.value);
      connectState.transactions.value.unshift(tx);
      connectState.transactionCount.value++;
      const msg = `<div><span>Update dao success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
      element.elMessage('success', msg, true);        
    }else{
      const tx = await greendao.mint(daoName.value, daoDesc.value, daoWebsite.value, daoAvatarUrl.value, daoPublic.value);
      connectState.transactions.value.unshift(tx);
      connectState.transactionCount.value++;
      const msg = `<div><span>Create dao success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
      element.elMessage('success', msg, true);      
    }    

    showAddNewDaoVisiable.value = false;

    handleClick();     

  }catch(e){
    element.alertMessage(e);
  }finally{
    loadDrawerStatus.value = false;
  }
}

//click to delete green dao
const onDeleteGreenDao = async (daoId:number) => {
  try{
    const tx = await greendao.burn(daoId);
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Delete dao success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);       

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }  
}

//click to join a green dao
const onJoinDao = async (daoId:number, address:string = connectState.userAddr.value) => {
  try{
    const tx = await greendao.joinDao(daoId, address);
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Join dao success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);       

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }  
}

//click to leave a green dao
const onLeaveDao = async (daoId:number, address:string = connectState.userAddr.value) => {
  try{
    const tx = await greendao.leaveDao(daoId, address);
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Leave dao success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);       

    handleClick();
  }catch(e){
    element.alertMessage(e);
  }  
}

//click to open the drawer to manage the dao members
const onManageDao = async (daoInfo:any) => {
  daoId.value = daoInfo.daoId;
  daoName.value = daoInfo.daoName;

  showManageDaoMemberVisiable.value = true;
}

//get green dao infos by page size and page count
const getGreenDaoCount = async (onlyOwner:boolean) => {

  const indexs = await greendao.getDaoIndexsByPageCount(pageSize.value, pageCount.value, onlyOwner);

  if(indexs.length < pageSize.value){
    hasMore.value = false;
  }else{
    hasMore.value = true;
  }

  const infoList = new Array();
  for(const i in indexs){
    const res = await greendao.getDaoInfoById(indexs[i]);

    res.daoIn = await greendao.checkInDao(res.daoId, connectState.userAddr.value);
    res.isOwner = res.daoOwner.toLowerCase() === connectState.userAddr.value.toLowerCase();

    infoList.push(res);
  }

  greenDaoList.value = infoList;
}

//on click for prev page
const onHandlePrev = async () => {
  if(pageCount.value > 0){
    pageCount.value--;
  }
  handleClick();
}

//on click for next page
const onHandleNext = async () => {
  if(hasMore.value){
    pageCount.value++;
  }
  handleClick();
}

//on refresh page
const handleClick = async () => {
  //wait for the active name change
  await tools.sleep(100);
    
  connectState.activeName.value = activeName.value;
  tools.setUrlParamter('activeName', activeName.value);
  try{
    loadStatus.value = true;
    if (!(await connected())){
      greenDaoList.value = new Array();
      return;
    }

    if(pageCount.value < 0){
      pageCount.value = 0;
    }

    const onlyOwner = activeName.value === 'mine';

    await getGreenDaoCount(onlyOwner);

  }catch(e){
    greenDaoList.value = new Array();
  }finally{
    loadStatus.value = false;
  }
}

//clean search content and bind search callback function
connectState.search = '';
connectState.searchCallback = handleClick;
//try get activeName from the url paramter
try{
  activeName.value = tools.getUrlParamter('activeName');
  if(activeName.value != 'all' && 
    activeName.value != 'mine'){
    activeName.value = 'all';
  }
}catch(e){
  activeName.value = 'all';
}
//update page size
handleClick();

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_document_copy = _resolveComponent("document-copy")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { style: {"background-color":"#ffffff"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tabs, {
              modelValue: _unref(activeName),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeName) ? (activeName).value = $event : null)),
              class: "file-tabs",
              onTabClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "All",
                  name: "all"
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Mine",
                  name: "mine"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              style: {"float":"right","margin-right":"50px"},
              onClick: onAddGreenDao
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_drawer, {
              modelValue: showManageDaoMemberVisiable.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showManageDaoMemberVisiable).value = $event)),
              direction: "rtl",
              "destroy-on-close": "",
              onOpened: onManageDaoMemberOpen
            }, {
              header: _withCtx(() => [
                _hoisted_3
              ]),
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_4, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_5, [
                      _hoisted_6,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Dao Id",
                        width: 200,
                        trigger: "hover",
                        content: "The id of the green dao."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_7, [
                      _createVNode(_component_el_input, {
                        modelValue: daoId.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((daoId).value = $event)),
                        disabled: ""
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (onClickToCopy(daoId.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_8, [
                      _hoisted_9,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Dao Name",
                        width: 200,
                        trigger: "hover",
                        content: "The name of the green dao."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_10, [
                      _createVNode(_component_el_input, {
                        modelValue: daoName.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((daoName).value = $event)),
                        disabled: ""
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (onClickToCopy(daoName.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_11,
                    _createElementVNode("td", _hoisted_12, [
                      _createVNode(_component_el_select, {
                        modelValue: daoMemberOperator.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((daoMemberOperator).value = $event)),
                        style: {"width":"100%","margin-left":"0px"},
                        placeholder: "Select Member Operator",
                        teleported: false,
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            key: "add",
                            label: "Add Members",
                            value: "add"
                          }),
                          _createVNode(_component_el_option, {
                            key: "delete",
                            label: "Delete Members",
                            value: "delete"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_13,
                    _createElementVNode("td", _hoisted_14, [
                      _createVNode(_component_el_input, {
                        modelValue: daoMemberAddress.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((daoMemberAddress).value = $event))
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (onClickToCopy(daoMemberAddress.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              footer: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  style: {"flex":"auto"},
                  "element-loading-text": "Submitting...",
                  "element-loading-spinner": svg,
                  "element-loading-svg-view-box": "-10, -10, 50, 50",
                  "element-loading-background": "#ffffff"
                }, [
                  _createVNode(_component_el_button, { onClick: cancelDaoMemberUpdate }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: confirmDaoMemberUpdate
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ])), [
                  [_directive_loading, loadDrawerStatus.value]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_drawer, {
              modelValue: showAddNewDaoVisiable.value,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((showAddNewDaoVisiable).value = $event)),
              direction: "rtl",
              "destroy-on-close": "",
              onOpened: onAddNewDaoOpen
            }, {
              header: _withCtx(() => [
                _hoisted_17
              ]),
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_18, [
                  (daoId.value > 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                        _createElementVNode("td", _hoisted_20, [
                          _hoisted_21,
                          _createVNode(_component_el_popover, {
                            placement: "top-start",
                            title: "Dao Id",
                            width: 200,
                            trigger: "hover",
                            content: "The id of the green dao."
                          }, {
                            reference: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_QuestionFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("td", _hoisted_22, [
                          _createVNode(_component_el_input, {
                            modelValue: daoId.value,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((daoId).value = $event)),
                            disabled: ""
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_el_icon, {
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (onClickToCopy(daoId.value)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_document_copy)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_23, [
                      _hoisted_24,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Dao Name",
                        width: 200,
                        trigger: "hover",
                        content: "The name of the green dao."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_25, [
                      _createVNode(_component_el_input, {
                        modelValue: daoName.value,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((daoName).value = $event))
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (onClickToCopy(daoName.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_26, [
                      _hoisted_27,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Dao Description",
                        width: 200,
                        trigger: "hover",
                        content: "The description about the detail infos of the green dao."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_28, [
                      _createVNode(_component_el_input, {
                        modelValue: daoDesc.value,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((daoDesc).value = $event)),
                        type: "textarea",
                        rows: "5"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  (daoId.value <= 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                        _createElementVNode("td", _hoisted_30, [
                          _hoisted_31,
                          _createVNode(_component_el_popover, {
                            placement: "top-start",
                            title: "Dao Type",
                            width: 200,
                            trigger: "hover",
                            content: "The type of the green dao. A public dao that every one can join it. And a private dao only the onwer can add the members."
                          }, {
                            reference: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_QuestionFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("td", _hoisted_32, [
                          _createVNode(_component_el_select, {
                            modelValue: daoPublic.value,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((daoPublic).value = $event)),
                            style: {"width":"100%","margin-left":"0px"},
                            placeholder: "Select Dao Type",
                            teleported: false,
                            filterable: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                key: "public",
                                label: "Public",
                                value: true
                              }),
                              _createVNode(_component_el_option, {
                                key: "private",
                                label: "Private",
                                value: false
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_33, [
                      _hoisted_34,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Dao Website",
                        width: 200,
                        trigger: "hover",
                        content: "The website of the green dao. You can input the url link directly or upload the website folder through the upload button."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_35, [
                      _createVNode(_component_el_input, {
                        modelValue: daoWebsite.value,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((daoWebsite).value = $event))
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (onClickToCopy(daoWebsite.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("tr", {
                    "element-loading-text": "Uploading...",
                    "element-loading-spinner": svg,
                    "element-loading-svg-view-box": "-10, -10, 50, 50",
                    "element-loading-background": "#ffffff"
                  }, [
                    _hoisted_36,
                    _createElementVNode("td", _hoisted_37, [
                      _createVNode(_component_el_upload, {
                        style: {"width":"100px","height":"0px","float":"right","margin-right":"100px"},
                        drag: false,
                        multiple: true,
                        class: "upload-website",
                        ref_key: "uploadWebsite",
                        ref: uploadWebsite,
                        action: "",
                        onChange: onChangeSelectWebsiteFolder,
                        onClick: onSelectWebsiteFolder,
                        accept: "",
                        limit: 0,
                        "show-file-list": false,
                        "auto-upload": false
                      }, {
                        trigger: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            style: {"float":"right","margin-right":"20px","width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_38
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512),
                      _createVNode(_component_el_button, {
                        type: "success",
                        style: {"float":"right"},
                        onClick: onUploadWebsiteFolder
                      }, {
                        default: _withCtx(() => [
                          _hoisted_39
                        ]),
                        _: 1
                      })
                    ])
                  ])), [
                    [_directive_loading, loadWebsiteStatus.value]
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_40, [
                      _hoisted_41,
                      _createVNode(_component_el_popover, {
                        placement: "top-start",
                        title: "Dao Avatar",
                        width: 200,
                        trigger: "hover",
                        content: "The avatar of the green dao. You can input the url link directly or upload the avatar image file through the upload button."
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("td", _hoisted_42, [
                      _createVNode(_component_el_input, {
                        modelValue: daoAvatarUrl.value,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((daoAvatarUrl).value = $event))
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, {
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (onClickToCopy(daoAvatarUrl.value)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("tr", {
                    "element-loading-text": "Uploading...",
                    "element-loading-spinner": svg,
                    "element-loading-svg-view-box": "-10, -10, 50, 50",
                    "element-loading-background": "#ffffff"
                  }, [
                    _hoisted_43,
                    _createElementVNode("td", _hoisted_44, [
                      _createVNode(_component_el_upload, {
                        style: {"width":"100px","height":"0px","float":"right","margin-right":"100px"},
                        drag: false,
                        multiple: false,
                        class: "upload-avatar",
                        ref_key: "uploadAvatar",
                        ref: uploadAvatar,
                        action: "",
                        onChange: onChangeSelectAvatarFile,
                        onClick: onSelectAvatarFile,
                        accept: "image/*",
                        limit: 1,
                        "show-file-list": false,
                        "on-exceed": handleAvtarExceed,
                        "auto-upload": false
                      }, {
                        trigger: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            style: {"float":"right","margin-right":"10px","width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_45
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512),
                      _createVNode(_component_el_button, {
                        type: "success",
                        style: {"float":"right"},
                        onClick: onUploadAvatarFile
                      }, {
                        default: _withCtx(() => [
                          _hoisted_46
                        ]),
                        _: 1
                      })
                    ])
                  ])), [
                    [_directive_loading, loadAvatarStatus.value]
                  ])
                ])
              ]),
              footer: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  style: {"flex":"auto"},
                  "element-loading-text": "Submitting...",
                  "element-loading-spinner": svg,
                  "element-loading-svg-view-box": "-10, -10, 50, 50",
                  "element-loading-background": "#ffffff"
                }, [
                  _createVNode(_component_el_button, { onClick: cancelDaoUpdate }, {
                    default: _withCtx(() => [
                      _hoisted_47
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: confirmDaoUpdate
                  }, {
                    default: _withCtx(() => [
                      _hoisted_48
                    ]),
                    _: 1
                  })
                ])), [
                  [_directive_loading, loadDrawerStatus.value]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_main, {
          style: {"height":"450px","margin-top":"20px"},
          "element-loading-text": "Loading...",
          "element-loading-spinner": svg,
          "element-loading-svg-view-box": "-10, -10, 50, 50",
          "element-loading-background": "#ffffff"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(greenDaoList.value, (info) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    key: info.daoId,
                    span: 8
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, { class: "box-card" }, {
                        header: _withCtx(() => [
                          _createVNode(_component_el_popover, {
                            placement: "bottom-start",
                            width: 230,
                            title: "Dao Info"
                          }, {
                            reference: _withCtx(() => [
                              _createVNode(_component_el_link, {
                                type: "success",
                                target: "_blank",
                                href: tokenExplorerUrl(_unref(greendao).getAddress(),info.daoId)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(info.daoName), 1)
                                ]),
                                _: 2
                              }, 1032, ["href"])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("h4", null, "Name: " + _toDisplayString(info.daoName), 1),
                              _createElementVNode("h4", null, [
                                _hoisted_49,
                                _createVNode(_component_el_link, {
                                  type: "success",
                                  target: "_blank",
                                  href: tokenExplorerUrl(_unref(greendao).getAddress(),info.daoId)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(info.daoId), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["href"])
                              ]),
                              _createElementVNode("h4", null, [
                                _hoisted_50,
                                _createVNode(_component_el_link, {
                                  type: "success",
                                  target: "_blank",
                                  href: addressExplorerUrl(info.daoOwner)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(info.daoOwner), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["href"])
                              ]),
                              _createElementVNode("h4", null, "Members: " + _toDisplayString(info.daoMembers), 1),
                              _createElementVNode("h4", null, "Public: " + _toDisplayString(info.daoPublic), 1),
                              _createElementVNode("h4", null, "Description: " + _toDisplayString(info.daoDesc), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("span", null, [
                            (_unref(activeName) === 'mine')
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "danger",
                                  style: {"float":"right"},
                                  size: "small",
                                  onClick: ($event: any) => (onDeleteGreenDao(info.daoId))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Delete)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_unref(activeName) === 'mine')
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  type: "primary",
                                  style: {"float":"right"},
                                  size: "small",
                                  onClick: ($event: any) => (onEditGreenDao(info))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Edit)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(info.daoDesc), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_link, {
                                type: "success",
                                target: "_blank",
                                href: info.daoWebsite,
                                style: {"margin-left":"70px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_badge, {
                                    value: info.daoMembers,
                                    class: "item",
                                    type: "primary"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_avatar, {
                                        src: info.daoAvatar,
                                        size: 100
                                      }, null, 8, ["src"])
                                    ]),
                                    _: 2
                                  }, 1032, ["value"])
                                ]),
                                _: 2
                              }, 1032, ["href"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { style: {"margin-top":"20px","float":"right"} }, {
                            default: _withCtx(() => [
                              (info.daoPublic && !info.daoIn && !info.isOwner)
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 0,
                                    type: "success",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (onJoinDao(info.daoId))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_51
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (info.daoPublic && info.daoIn && !info.isOwner)
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 1,
                                    type: "success",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (onLeaveDao(info.daoId))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_52
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (!info.daoPublic && info.isOwner)
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 2,
                                    type: "success",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (onManageDao(info))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_53
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_link, {
                                type: "success",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (redirectUrl('2', info.daoId))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_54
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_link, {
                                type: "success",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (redirectUrl('3', info.daoId))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_55
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_link, {
                                type: "success",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (redirectUrl('4', info.daoId))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_56
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_link, {
                                type: "success",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (redirectUrl('5', info.daoId))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_57
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_loading, loadStatus.value]
        ]),
        _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-top":"10px"},
                onClick: onHandlePrev
              }, {
                default: _withCtx(() => [
                  _hoisted_58
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-top":"10px"},
                onClick: onHandleNext,
                disabled: !hasMore.value
              }, {
                default: _withCtx(() => [
                  _hoisted_59
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})